import { Component } from '@angular/core';

@Component({
  selector: 'app-next-gen-tnc',
  standalone: true,
  imports: [],
  templateUrl: './next-gen-tnc.component.html',
  styleUrl: './next-gen-tnc.component.scss'
})
export class NextGenTncComponent {

}
